/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { HtmlSanitizer } from 'roosterjs';
import { isUndefined } from 'underscore';

import {
  usePreviewPageContext,
  useClientContext,
  ComponentLoadingStatus,
} from '@bingads-webui-campaign-react/smart-page-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';
import { Loading } from '@bingads-webui-campaign-react/smart-component-primitive';
import { SpinnerSize } from '@fluentui/react';

import { dataProperties } from './data-config';

const getStyles = (components, { palette = {} }) => {
  const description = {
    margin: 0,
    fontSize: 16,
    fontWeight: 'normal',
    lineHeight: '20px',
    color: palette.secondaryText,
    maxWidth: 720,
    wordBreak: 'break-word',
    position: 'relative',
  };

  const headline = {
    ...components.truncate,
    fontSize: 64,
    lineHeight: '64px',
    color: palette.primaryText,
    fontWeight: 'bold',
    margin: 0,
    paddingBottom: 32,
    textAlign: 'center',
  };

  return ({
    container: {
      ...components.section,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    headline,
    mobileHeadline: {
      ...headline,
      fontSize: 48,
      lineHeight: '56.25px',
      paddingBottom: 28,
    },
    description,
    mobileDescription: {
      ...description,
      marginLeft: 32.5,
      marginRight: 33.5,
    },
  });
};

export const UnStyledSmartIntroductionView = ({
  classes,
  headline,
  defaultHeadline,
  description,
  defaultDescription,
  id,
}) => {
  const { isMobile } = useClientContext();
  const { elementsLoadingStatus } = usePreviewPageContext();

  const descriptionContent = isUndefined(description) ? defaultDescription : description;
  const descriptionHtmlContent =
    HtmlSanitizer.sanitizeHtml(HtmlSanitizer.convertInlineCss(descriptionContent));

  return (
    <div
      className={classes.container}
      id={id}
    >
      <h1
        className={isMobile ? classes.mobileHeadline : classes.headline}
        data-property={dataProperties.headline}
      >
        {headline || defaultHeadline}
      </h1>
      <h2
        className={isMobile ? classes.mobileDescription : classes.description}
        data-property={dataProperties.description}
      >
        {
          elementsLoadingStatus.description
            && elementsLoadingStatus.description.status === ComponentLoadingStatus.LOADING
            ? <Loading
              className={classes.loading}
              size={SpinnerSize.small}
              label={elementsLoadingStatus.description.reason}
            />
            : <div dangerouslySetInnerHTML={{ __html: descriptionHtmlContent }} />
        }
      </h2>
    </div>
  );
};

UnStyledSmartIntroductionView.propTypes = {
  classes: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.string.isRequired,
  headline: PropTypes.string,
  defaultHeadline: PropTypes.string.isRequired,
  description: PropTypes.string,
  defaultDescription: PropTypes.string.isRequired,
};

UnStyledSmartIntroductionView.defaultProps = {
  headline: undefined,
  description: undefined,
};

export const SmartIntroductionView = withErrorView(withDefaultStyles(
  UnStyledSmartIntroductionView,
  getStyles
), 'componentMode');
